import React from 'react';  
import { Line } from 'react-chartjs-2';  
import 'chartjs-adapter-date-fns';  
import { format } from 'date-fns';  
import styled from 'styled-components';  
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import { Chart } from 'chart.js';  
// import zoomPlugin from 'chartjs-plugin-zoom';  
  
Chart.register(ChartDataLabels);  
// Chart.register(ChartDataLabels, zoomPlugin);  
  
const ChartsContainer = styled.div`  
  background-color: #ffffff;  
  border-radius: 15px;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  
  padding: 5px;  
  display: flex;  
  flex-direction: column;  
  gap: 20px;  
  overflow-y: auto;  
  max-height: 85vh;  
  // margin-bottom: 20px;
  width: 100%; 
  min-height: 300px;
  max-height: 300px;
  
  @media (max-width: 768px) {  
    width: auto;
    canvas {  
      height: 500px !important;  
    }  
  }  
`;  
  
const ChartComponent = ({ data, selectedCity, showPrices, chartType }) => {  
  const oneMonthMs = 30 * 24 * 60 * 60 * 1000; // 1ヶ月をミリ秒で表現  
  
  const filteredData = data.filter(item => item.CityName === selectedCity);  
  const productionAreas = Array.from(new Set(filteredData.map(item => item.ProductionAreaName).filter(area => area !== null)));  
  
  const datasets = productionAreas.map(area => {  
    const areaData = filteredData.filter(item => item.ProductionAreaName === area);  
    const processedData = [];  
    areaData.forEach((item, index) => {  
      const currentDate = new Date(item.TargetDate);  
      if (index > 0) {  
        const previousDate = new Date(areaData[index - 1].TargetDate);  
        const gap = currentDate - previousDate;  
        if (gap > oneMonthMs) {  
          processedData.push({ x: previousDate, y: null });  
        }  
      }  
      processedData.push({  
        x: currentDate,  
        y: item.AveragePrice  
      });  
    });  
    return {  
      label: area,  
      data: processedData,  
      fill: false,  
      borderColor: getRandomColor(),  
      spanGaps: oneMonthMs, // ギャップを手動で挿入するためfalseに設定  
    };  
  });  
  
  const averageData = filteredData.reduce((acc, item) => {  
    // const date = new Date(item.TargetDate).toISOString().split('T')[0];  
    const date = new Date(item.TargetDate).toLocaleDateString('ja-JP');  // ローカル日付を使用

    if (!acc[date]) {  
      acc[date] = { total: 0, count: 0 };  
    }  
    acc[date].total += item.AveragePrice;  
    acc[date].count += 1;  
    return acc;  
  }, {});  
  
  const averageDataset = Object.keys(averageData).map(date => ({  
    x: new Date(date),  
    y: Math.round(averageData[date].total / averageData[date].count)  
  }));  
  
  const nationalAverageData = data.reduce((acc, item) => {  
    // const date = new Date(item.TargetDate).toISOString().split('T')[0];  
    const date = new Date(item.TargetDate).toLocaleDateString('ja-JP');  // ローカル日付を使用

    if (!acc[date]) {  
      acc[date] = { total: 0, count: 0 };  
    }  
    acc[date].total += item.AveragePrice;  
    acc[date].count += 1;  
    return acc;  
  }, {});  
  
  const nationalAverageDataset = Object.keys(nationalAverageData).map(date => ({  
    x: new Date(date),  
    y: Math.round(nationalAverageData[date].total / nationalAverageData[date].count)  
  }));  
  
  const chartData = {  
    datasets: datasets,  
  };  
  
  const averageChartData = {  
    datasets: [{  
      label: '平均価格',  
      data: averageDataset,  
      fill: false,  
      borderColor: 'blue',  
      spanGaps: oneMonthMs, // ギャップを手動で挿入するためfalseに設定  
    }]  
  };  
  
  const nationalAverageChartData = {  
    datasets: [{  
      label: '全国平均価格',  
      data: nationalAverageDataset,  
      fill: false,  
      borderColor: 'green',  
      spanGaps: oneMonthMs, // ギャップを手動で挿入するためfalseに設定  
    }]  
  };  
  
  const options = {  
    maintainAspectRatio: false,  
    scales: {  
      x: {  
        type: 'time',  
        time: {  
          unit: 'day',  
          tooltipFormat: 'yyyy_MM_dd',  
          displayFormats: {  
            day: 'yyyy_MM_dd',  
          },  
        },  
        // title: {  
        //   display: true,  
        //   text: 'Date',  
        // },  
        ticks: {  
          callback: function (value, index, values) {  
            return format(new Date(value), 'yyyy_MM_dd');  
          },  
        },  
      },  
      y: {  
        title: {  
          display: true,  
          text: '円',  
        },  
      },  
    },  
    plugins: {  
      legend: {  
        position: 'top',  
      },  
      datalabels: {  
        display: function (context) {  
          return showPrices && context.dataIndex % 5 === 0;  
        },  
        color: 'black',  
        anchor: 'end',  
        align: 'top',  
        formatter: (value, context) => {  
          return value.y ? `${value.y}` : '';  
        },  
      },  
      zoom: {  
        pan: {  
          enabled: true,  
          mode: 'x',  
        },  
        zoom: {  
          wheel: {  
            enabled: true,  
          },  
          pinch: {  
            enabled: true,  
          },  
          mode: 'x',  
        },  
      },  
    },  
    layout: {  
      padding: {  
        right: 0,  
        left: 0,  
      },  
    },  
  };  
  
  function getRandomColor() {  
    const letters = '0123456789ABCDEF';  
    let color = '#';  
    for (let i = 0; i < 6; i++) {  
      color += letters[Math.floor(Math.random() * 16)];  
    }  
    return color;  
  }  
  
  let chartToRender;  
  switch (chartType) {  
    case 'production':  
      chartToRender = <Line data={chartData} options={options} />;  
      break;  
    case 'average':  
      chartToRender = <Line data={averageChartData} options={options} />;  
      break;  
    case 'national':  
      chartToRender = <Line data={nationalAverageChartData} options={options} />;  
      break;  
    default:  
      chartToRender = <Line data={chartData} options={options} />;  
  }  
  
  return (  
    <ChartsContainer>  
      {chartToRender}  
    </ChartsContainer>  
  );  
};  
  
export default ChartComponent;  
